import { Link, UIMatch, useMatches, useNavigate } from 'react-router-dom'
import { Fragment } from 'react'
import Button from '@/shared/Buttons/Button'
import ArrowBack from '@/assets/icons/arrowLeft.svg?react'

interface IProps {
  lastMatch?: Pick<UIMatch, 'handle' | 'pathname' | 'id'>
  crumbs?: { id: string | number; to: string | null; title: string; replace?: boolean }[]
  withBackButton?: boolean
}

const NavigationBreadcrumbs = (props: IProps) => {
  const navigate = useNavigate()
  const matches = useMatches()

  const renderMatched = () => {
    const allMatches = props.lastMatch ? [...matches, props.lastMatch] : matches

    return allMatches.map((m, index) => {
      const isLast = index === allMatches.length - 1

      if (typeof (m.handle as any)?.crumb === 'function') {
        return (
          <Fragment key={index}>
            <div>
              <Link
                to={(m.handle as any)?.navTo || m.pathname}
                className={`text-nm text-breadcrumb ${isLast ? 'text-default' : 'text-secondary'} ${(m.handle as any).canNavigate ? '' : 'link-disabled'}`}
              >
                {(m.handle as any).crumb()}
              </Link>
            </div>
            {!isLast && <span className="text-nm text-secondary">/</span>}
          </Fragment>
        )
      }

      return null
    })
  }

  const renderFormProps = () => {
    return props.crumbs.map((crumb, index) => (
      <Fragment key={index}>
        <div>
          <Link
            replace={crumb.replace}
            to={crumb.to}
            className={`text-nm text-breadcrumb ${index === props.crumbs.length - 1 ? 'text-default' : 'text-secondary'} ${crumb.to ? '' : 'link-disabled'}`}
          >
            {crumb.title}
          </Link>
        </div>
        {index !== props.crumbs.length - 1 && <span className="text-nm text-secondary">/</span>}
      </Fragment>
    ))
  }

  const renderCrumbs = () => {
    if (props.crumbs) {
      return renderFormProps()
    }

    return renderMatched()
  }

  return (
    <div className="inline-flex-gap center" style={{ gap: '4px' }}>
      {props.withBackButton && (
        <div style={{ marginRight: '12px' }}>
          <Button type="default" size="default" icon={<ArrowBack />} onClick={() => navigate(-1)} />
        </div>
      )}
      {renderCrumbs()}
    </div>
  )
}

export default NavigationBreadcrumbs
